import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { NgFor, NgIf, ViewportScroller } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { takeUntil } from 'rxjs/operators';
import { LanguageService } from '../../../core/services/language.service';
import { SharedModule } from '../../../shared/shared.module';
import { QuestionResponseData } from './help-page.types';
import { HelpApiService } from '../../../core/modules/help/help-api.service';

@Component({
  selector: 'tax-help',
  templateUrl: './help-page.component.html',
  styleUrls: ['./help-page.component.sass'],
  standalone: true,
  imports: [
    NgIf,
    NgFor,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
  ],
})

export class HelpPageComponent implements OnInit, OnDestroy {
  feedbackForm: UntypedFormGroup = new UntypedFormGroup({
    email: new UntypedFormControl('', [
      Validators.email,
      Validators.required,
    ]),
    subject: new UntypedFormControl('', Validators.required),
    text: new UntypedFormControl('', Validators.required),
  });

  searchText: string = '';
  adminText: string = '';
  data: QuestionResponseData[] = [
    {
      question: 'help.questions.enter', answer: 'help.answers.enter', visible: false,
    },
    {
      question: 'help.questions.access', answer: 'help.answers.access', visible: false,
    },
    {
      question: 'help.questions.registration', answer: 'help.answers.registration', visible: false,
    },
    {
      question: 'help.questions.kkm.registration', answer: 'help.answers.kkm.registration', visible: false,
    },
    {
      question: 'help.questions.kkm.unregistr', answer: 'help.answers.kkm.unregistr', visible: false,
    },
    {
      question: 'help.questions.xreport', answer: 'help.answers.xreport', visible: false,
    },
    {
      question: 'help.questions.zreport', answer: 'help.answers.zreport', visible: false,
    },
    {
      question: 'help.questions.show.xreport', answer: 'help.answers.show.xreport', visible: false,
    },
    {
      question: 'help.questions.show.zreport', answer: 'help.answers.show.zreport', visible: false,
    },
    {
      question: 'help.questions.id', answer: 'help.answers.id', visible: false,
    },
    {
      question: 'help.questions.token', answer: 'help.answers.token', visible: false,
    },
    {
      question: 'help.questions.get.id', answer: 'help.answers.get.id', visible: false,
    },
    {
      question: 'help.questions.get.token', answer: 'help.answers.get.token', visible: false,
    },
    {
      question: 'help.questions.site.404', answer: 'help.answers.site.404', visible: false,
    },
    {
      question: 'help.questions.empty', answer: 'help.answers.empty', visible: false,
    },
    {
      question: 'help.questions.token.error', answer: 'help.answers.token.error', visible: false,
    },
    {
      question: 'help.questions.transaction', answer: 'help.answers.transaction', visible: false,
    },
    {
      question: 'help.questions.password', answer: 'help.answers.password', visible: false,
    },
  ];

  sections: Array<{ question: string; answer: string; visible: boolean }> = [];

  private destroy$: Subject<void> = new Subject<void>();

  constructor(
    private helpApiService: HelpApiService,
    private languageService: LanguageService,
    private viewportScroller: ViewportScroller,
    private translate: TranslateService,
  ) { }

  ngOnInit(): void {
    this.languageService.languageChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        () => this.getHelpText(),
      );
    this.sections = [...this.data];
  }

  getHelpText(): void {
    this.helpApiService.fetchHelpText()
      .pipe(takeUntil(this.destroy$))
      .subscribe(response => this.adminText = response);
  }

  onInput(event: any): void {
    // @ts-ignore
    const searchText = event.target.value;
    this.sections = this.data.filter(section => this.translate.instant(section.question).includes(searchText.toUpperCase())
      || this.translate.instant(section.question).includes(searchText.toLowerCase()));
  }

  onClick(elementId: string): void {
    this.viewportScroller.scrollToAnchor(elementId);
  }

  sendEmail(elementId: string): void {
    this.helpApiService.sendFeedback(this.feedbackForm.value)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        () => {
          this.onClick(elementId);
          this.feedbackForm.reset();
        },
      );
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }
}
